import { Component, Input, OnInit } from '@angular/core';

import { AppNotify } from '../../services/app-notifier.service';

@Component({
  selector: 'notify',
  templateUrl: './notify.component.html',
  styleUrls: ['./notify.component.scss']
})
export class NotifyComponent implements OnInit {

  @Input() notification: AppNotify

  constructor() { }

  ngOnInit() {
  }

}
